<template>
  <div>
    <div>
      <div class="col">
        <div class="CadastrarServentia--header row align-items-center justify-content-between">
          <div class="col-3" />
          <div class="col">
            Último livro usado
          </div>
          <div class="col">
            Página atual
          </div>
          <div class="col">
            Termo atual
          </div>
          <div class="col">
            Lado atual
          </div>
        </div>
        <div v-for="(val, index) in listaDeSequenlivros"
             :key="`config_livro_${ _uid }_${ index }`"
             class="CadastrarServentia--item row align-items-center justify-content-between">
          <div class="col-3 text-bold text-left">
            <div class="pl-2">
              {{ val.titulo }}
            </div>
          </div>
          <div class="col">
            <input :id="`qtdFolha-${val.livro}`"
                   v-model="val.num_livro_atual"
                   v-validate="'max_value:99999'"
                   class="form-control form-control-sm text-center"
                   min="1"
                   :name="`qtdFolha-${val.livro}`"
                   placeholder="00"
                   type="number"
                   :class="{ 'is-invalid': errors.has(`qtdFolha-${val.livro}`) }">
          </div>
          <div class="col">
            <input :id="`pagIni-${val.livro}`"
                   v-model="val.folha_atual"
                   v-validate="'max_value:99999'"
                   class="form-control form-control-sm text-center"
                   min="1"
                   :name="`pagIni-${val.livro}`"
                   placeholder="00"
                   type="number"
                   :class="{ 'is-invalid': errors.has(`pagIni-${val.livro}`) }">
          </div>
          <div class="col">
            <input :id="`pagFinal-${val.livro}`"
                   v-model="val.termo_atual"
                   v-validate="'max_value:9999999'"
                   class="form-control form-control-sm text-center"
                   min="1"
                   :name="`pagFinal-${val.livro}`"
                   placeholder="00"
                   type="number"
                   :class="{ 'is-invalid': errors.has(`pagFinal-${val.livro}`) }">
          </div>
          <div class="col">
            <select :id="`qtdTermoFolha-${val.livro}`"
                    v-model="val.lado_atual"
                    class="custom-select custom-select-sm form-control-sm"
                    min="1"
                    :name="`qtdTermoFolha-${val.livro}`"
                    type="number">
              <option value="">
                Selecione
              </option>
              <option :value="'FRENTE'">
                Frente
              </option>
              <option :value="'VERSO'">
                Verso
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!propWizard"
         class="d-flex justify-content-end mt-2">
      <div class="d-inline-block">
        <button class="btn btn-sm btn-primary"
                type="submit"
                @click="sendSequence()">
          Salvar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { listaDeSequenlivros } from '@/utils/serventiaLists'
  import objSwal from '@/constants/swalValues'
  import Swal from 'sweetalert2'
  import { mapGetters } from 'vuex'

  /* services */
  import LivroService from '@/services/LivroService'

  export default {
    name: 'FormSequenLivros',
    props: {
      propWizard: {type: Boolean, default: false}
    },
    data () {
      return {
        listaDeSequenlivros
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
      }),
    },
    watch: {
      listaDeSequenlivros () {
        if (this.propWizard) this.$emit('changed', this.listaDeSequenlivros)
      }
    },
    mounted () {
      this.getSequence()
    },
    methods: {
      async sendSequence () {
        this.$validator.validate().then(async res => {
          if (res) {
            try {
              let listaEnviados = []
              objSwal.success.title = 'Dados Atualizados!'
              objSwal.success.text = ''

              loader({ text: 'Atualizando dados', active: true })

              let aux = 0

              for (let val of this.listaDeSequenlivros) {
                if (val.lado_atual !== '') {
                  let objEnvio = { ...val, cartorio_id: this.$store.state.auth.cartorio_id }
                  delete objEnvio.titulo
                  objEnvio.cartorio_id = this.$store.state.auth.cartorio_id

                  await LivroService.sequenLivro(objEnvio).then(res => listaEnviados.push({ ...res.data, livroEnviado: val }))
                } else if (val.num_livro_atual || val.folha_atual || val.termo_atual || val.lado_atual) {
                  aux = aux + 1
                }
              }

              if (aux > 0) {
                objSwal.error.title = 'Preencha os campos corretamente!'
                objSwal.error.text = ''

                return Swal.fire(objSwal.error)
              } else {
                this.getSequence()


                return Swal.fire(objSwal.success)
              }
            } catch (error) {
              const message = getErrors(error)

              return displayMessage('error', 'Erro!', message.message)
            } finally {
              loader({ text: '', active: false })
            }
          } else {
            displayMessage('error', 'Preencha os campos corretamente!')
          }
        })
      },
      async getSequence () {
        loader({ text: 'Buscando sequência de livros...', active: true })

        const params = {
          cartorio_id: this.$store.state.auth.cartorio_id
        }

        await LivroService.getSequenLivro(params).then(res => {
          return this.listaDeSequenlivros = this.listaDeSequenlivros.map(val => {
            let check = res.data.filter(item => (item.livro === val.livro))
            return check.length ? { ...val, ...check[0] } : val
          })
        }).finally(loader({ text: '', active: false }))
      }
    }
  }
</script>

<style scoped></style>
